"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileConfig = exports.ConsentService = exports.ConsentSDK = void 0;
const t = __importStar(require("io-ts"));
exports.ConsentSDK = t.type({
    /** Unique identifier for the SDK */
    id: t.string,
    /** airgap purposes applicable to this SDK */
    purposes: t.array(t.string),
});
exports.ConsentService = t.intersection([
    t.type({
        name: t.string,
    }),
    t.partial({
        sdks: t.array(exports.ConsentSDK),
        tcfId: t.number,
    }),
]);
exports.MobileConfig = t.type({
    services: t.array(exports.ConsentService),
});
//# sourceMappingURL=mobile.js.map